module.exports = __webpack_public_path__ + "static/img/1_0017.fa89c51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0017.jpg
// module id = WN8B
// module chunks = 0